import {Box} from 'src/design/atoms/Box';
import React from 'react';

import type {AssetResponse} from 'src/api/ProactApiClient';
import {Description} from 'src/design/atoms/Description';
import {Subtitle} from 'src/design/atoms/Typography';
import {QrCodeGenerator} from 'src/design/organisms/QrCodeGenerator';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export interface AssetQRCodeTabProps {
  id?: number;
  item?: AssetResponse;
}
export const AssetQRCodeTab: React.FC<AssetQRCodeTabProps> = ({id, item}) => {
  const QRCodeUrl = `${window.location.hostname}${PathUtility.AssetView(
    String(id),
    'overview'
  )}`;

  return (
    <>
      <Box mb="md">
        <Subtitle text={`${item?.name} QR Code`} />
        <Description text="Use this QR Code to access this asset record. Scanning this QR Code will give you the specific website URL to this web page." />
      </Box>
      <QrCodeGenerator
        title={`${item?.name} Asset QR Code`}
        value={QRCodeUrl}
      />
    </>
  );
};
